import i18n from 'modules/core/lib/i18n'

const PRIORITY_OPTIONS = ['critical', 'high', 'medium', 'low'] as const

export const getTicketPriorityOptions = () => {
  return PRIORITY_OPTIONS
}

export const getTicketPriorityLabel = (priority: string) => {
  switch (priority) {
    case 'critical':
      return i18n.t('ticketing.inbox.priority.critical')
    case 'high':
      return i18n.t('ticketing.inbox.priority.high')
    case 'medium':
      return i18n.t('ticketing.inbox.priority.medium')
    case 'low':
      return i18n.t('ticketing.inbox.priority.low')
    default:
      return priority
  }
}

export const getTicketPriorityVariant = (priority: string) => {
  switch (priority) {
    case 'critical':
      return 'critical'
    case 'high':
      return 'warning'
    case 'medium':
      return 'info'
    case 'low':
      return 'neutral'
    default:
      return 'neutral'
  }
}
